import * as ktx2decoder from "ktx2decoder/legacy/legacy";

export { ktx2decoder };
export default ktx2decoder;
